var initEnhancedSearch = function(){
  $.each($('input[name="q"]'),function(){
  	var obj=$(this);
    obj.attr("autocomplete","off");
    obj.addClass('enhanced-search-input');
    var form = obj.closest('form');
    	form.attr('action','/pages/search-results-page')
    	.addClass('enhanced-search-form');
    if(form.parent("div").length){
      form.parent("div").addClass("enhanced-search");
    }else{
    	if(!form.parent().hasClass("enhanced-search")) 
      		form.wrap( "<div class='enhanced-search'></div>" );
    }    
    $( ".enhanced-search-content-clone" )
    	.clone()
    	.removeClass('enhanced-search-content-clone')
    	.addClass('enhanced-search-content')
    	.insertAfter ( form )
    .css('width',$(this).outerWidth()<300?'500':$(this).outerWidth());
  })
  if($(".enhanced-search-overlay").length<=0) $("body").append('<div class="enhanced-search-overlay" style="display: none;"></div>');
}
function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
var focused
var renderSuggestions = function (suggestions) {


            if (suggestions.length > 0) {
                $('.enhanced-search-suggestion').show()
            } else {
                $('.enhanced-search-suggestion').hide()
                return;
            }

            suggestions.length = Math.min(suggestions.length, 4);


            var output = ''
            suggestions.forEach(suggestion => {
                output += '<a class="pill test" href="/pages/search-results-page?q=' + escape(suggestion) + '">' + suggestion + '</a>';
            });

            $('.enhanced-search-suggestions-content').html(
                output
            )
        }

        var renderCollections = function (collections) {

            if (collections.length > 0) {
                $('.enhanced-search-collections').show()
            } else {
                $('.enhanced-search-collections').hide()
                return;
            }

            collections.length = Math.min(collections.length, 1);

            var output = '<ul>'
            collections.forEach(collection => {
                output += '<li><a class="test" href="' + collection.link + '">' + collection.title + '</a></li>';
            });
            output += '</ul>'

            $('.enhanced-search-collections-content').html(
                output
            )
        }

        var renderPages = function (pages) {

            $('.enhanced-search-pages').hide()
            return;
            if (pages.length > 0) {
                $('.enhanced-search-pages').show()
            } else {
                $('.enhanced-search-pages').hide()
                return;
            }

            pages.length = Math.min(pages.length, 3);
            var output = '<ul>'
            pages.forEach(page => {
                output += '<li><a href="' + page.link + '">' + page.title + '</a></li>';
            });
            output += '</ul>'

            $('.enhanced-search-pages-content').html(
                output
            )
        }

        var renderProducts = function (products, totalItems) {

            if (products.length > 0) {
                $('.enhanced-search-products').show()
            } else {
                $('.enhanced-search-products').hide()
                return;
            }

            products.length = Math.min(products.length, 6);

            var output = '<ul>'
            products.forEach(product => {
                let variant = product.shopify_variants[0];
                let rate = parseInt(product.reviews_average_score)

                let off = null

                if (parseInt(variant.list_price) > 0) {
                    off = Math.ceil(100 - (parseFloat(variant.price) / parseFloat(variant.list_price) * 100))
                }
                let item = "<li>";
                   item+=" <a href='"+product.link+"'>";
                   item+="      <img src='"+product.shopify_images[0]+"'>";
                   item+="      <div>";
                   item+="          <span class='title'>"+product.title+"</span>";
                   item+="          <span class='price'>$"+numberWithCommas(parseInt(variant.price))+" "+ (off ? "<span class='pill'>"+off+"% OFF</span>" : '')+"</span>";
                   item+=           rate ? "<span class='rate'> <span class='stars'> "+'★'.repeat(rate) + '☆'.repeat(5 - rate)+" </span> "+product.total_reviews+" Review(s) </span>" : '';
                   item+="     </div>";
                   item+=" </a>";
                   item+="</li>";
                
                output += item;
            });
            output += '</ul>'

            $('.enhanced-search-products-content').html(
                output
            )

            if(focused){
              $('.enhanced-search-products-footer').html(
                '<a href="/pages/search-results-page?q=' + escape(focused.val()) + '">View all <span class="enhanced-search-products-count">' + totalItems + '</span> items</a>'
            	)
            }
            


        }


        window.onEnhancedSearchResult = function (data) {
            $(".enhanced-search-result").show();
            $(".enhanced-search-loading").hide();
            $(".enhanced-search-error").hide()


            $('.enhanced-search-suggestions-content').html(
                ''
            )
            $('.enhanced-search-products-content').html(
                ''
            )
            $('.enhanced-search-collections-content').html(
                ''
            )

            if (data.totalItems == 0 && data.totalCategories == 0) {
                $(".enhanced-search-result").hide();
                $(".enhanced-search-error").html("<span>Sorry, nothing found for <strong>" + $('.enhanced-search-input').val() + "</strong>.</span>");
                $(".enhanced-search-error").show()
            } else {
                renderSuggestions(data.suggestions)
                renderCollections(data.categories)
                renderProducts(data.items, data.totalItems)
            }
        }



        var currentRequest = null;

        $(document).on('click', '.enhanced-search-overlay', function () {

            if (currentRequest != null) {
                currentRequest.abort();
            }

 
            $(".enhanced-search-content").hide();
            $(".enhanced-search-overlay").hide();
            $('.enhanced-search-input').val(null);
        })
        $(document).on('focus', '.enhanced-search-input', function (e) {
        $(".enhanced-search-content").hide()
        })
        $(document).on('input', '.enhanced-search-input', function (e) {
			//wrapSearchForm($(this));
           var searchContent=$(this).closest('form').next(".enhanced-search-content");
            $(".enhanced-search-overlay").show()
            searchContent.show();
            $(".enhanced-search-error").html('');
            $(".enhanced-search-error").hide()
            $(".enhanced-search-result").hide();


            if (!this.value) {
                $(".enhanced-search-content").hide();
                $(".enhanced-search-overlay").hide()
                return;
            }

            $(".enhanced-search-loading").show();

            if (currentRequest != null) {
                currentRequest.abort();
            }

          focused=$(this)
            currentRequest = $.ajax({
                url: 'https://www.searchanise.com/getwidgets?suggestions=true&categories=true&startIndex=0&output=jsonp&callback=onEnhancedSearchResult&api_key=7I9N0F6L4v&q=' + escape(this.value),
                async: true,
                dataType: "jsonp",
                jsonpCallback: "onEnhancedSearchResult"
            });

        });

$(document).ready(function(){
	initEnhancedSearch();
})